var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 14,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1222 45V41.0114L19.4418 32.3821C20.2344 31.6151 20.8991 30.9247 21.4361 30.3111C21.9815 29.6974 22.3949 29.0966 22.6761 28.5085C22.9574 27.9119 23.098 27.2685 23.098 26.5781C23.098 25.8111 22.9233 25.1506 22.5739 24.5966C22.2244 24.0341 21.7472 23.6037 21.142 23.3054C20.5369 22.9986 19.8509 22.8452 19.0838 22.8452C18.2827 22.8452 17.5838 23.0071 16.9872 23.331C16.3906 23.6548 15.9304 24.1193 15.6065 24.7244C15.2827 25.3295 15.1207 26.0497 15.1207 26.8849H9.86648C9.86648 25.1719 10.2543 23.6847 11.0298 22.4233C11.8054 21.1619 12.892 20.1861 14.2898 19.4957C15.6875 18.8054 17.2983 18.4602 19.1222 18.4602C20.9972 18.4602 22.6293 18.7926 24.0185 19.4574C25.4162 20.1136 26.5028 21.0256 27.2784 22.1932C28.054 23.3608 28.4418 24.6989 28.4418 26.2074C28.4418 27.196 28.2457 28.1719 27.8537 29.1349C27.4702 30.098 26.7841 31.1676 25.7955 32.3438C24.8068 33.5114 23.4134 34.9134 21.6151 36.5497L17.7926 40.2955V40.4744H28.7869V45H10.1222ZM42.2326 45H32.9513V18.8182H42.3093C44.9428 18.8182 47.2099 19.3423 49.1104 20.3906C51.011 21.4304 52.4727 22.9261 53.4954 24.8778C54.5266 26.8295 55.0423 29.1648 55.0423 31.8835C55.0423 34.6108 54.5266 36.9545 53.4954 38.9148C52.4727 40.875 51.0025 42.3793 49.0849 43.4276C47.1758 44.4759 44.8917 45 42.2326 45ZM38.4869 40.2571H42.0025C43.6388 40.2571 45.0153 39.9673 46.1317 39.3878C47.2567 38.7997 48.1005 37.892 48.663 36.6648C49.234 35.429 49.5195 33.8352 49.5195 31.8835C49.5195 29.9489 49.234 28.3679 48.663 27.1406C48.1005 25.9134 47.261 25.0099 46.1445 24.4304C45.0281 23.8509 43.6516 23.5611 42.0153 23.5611H38.4869V40.2571Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D);
export default __webpack_public_path__ + "static/media/2D.7e7f7ba9b9a47c561411b1a539dbed14.svg";
export { ForwardRef as ReactComponent };